export default __webpack_public_path__ + "static/media/media.13d2c4e6.png";